<template>
  <form @submit.prevent>
    <div>
      <b-tabs v-if="showLibraryItems" justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
        <b-tab :active="showLibraryItems">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">{{ $t("common.library") }}</span>
          </template>

          <LibraryItems rightPanelId="sidebar-new-data" organizationScopedState="organizationData" libraryScopedState="data" libraryScopedStateCategory="dataCategory" />
        </b-tab>

        <b-tab :active="isEditMode">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-user"></i>
            </span>
            <span class="d-none d-sm-inline-block">
              <span v-if="isEditMode">{{ $t("common.update") }}</span>
              <span v-else>{{ $t("data.new") }}</span>
            </span>
          </template>

          <sweet-input
            :isValid="!$v.form.name.$error"
            @input="$v.form.name.$touch()"
            v-model="form.name"
            type="text"
            layout="vertical"
            :placeholder="$t('data.text')"
            :label="$t('data.text')"
          />

          <div class="col-mr-5 mt-3">
            <right-panel class="float-right mt-1 " id="sidebar-new-data-category" width="650px" :icon="'mdi mdi-plus'" :text="$t('data-category.new')" @hidden="rightPanelClosed">
              <div class="pl-5 pr-5">
                <Form :hide-library="true" @onSave="onFormSave" />
              </div>
            </right-panel>
          </div>
          <h6 class="mt-4">{{ $t("data-category.text") }}</h6>
          <filter-select
            id="categoryFilter"
            ref="categoryFilter"
            :placeholder="$t('data-category.text')"
            :multiple="false"
            @filter="onCategorySearch"
            :selected="form.category"
            @changed="onCategorySelect"
          />

          <sweet-button
            @click="save()"
            type="submit"
            :loading="isUpdating"
            :disabled="isUpdating || $v.$invalid"
            variant="success"
            icon="mdi mdi-check"
            size="sm"
            buttonClass="mt-2"
          >
            {{ $t("common.save") }}
          </sweet-button>
        </b-tab>
      </b-tabs>

      <div v-else>
        <h2>
          <span v-if="!showLibraryItems && isEditMode">{{ entityName }} {{ $t("common.update") }}</span>
          <span v-else>{{ $t("data.new") }}</span>
        </h2>

        <sweet-input
          :isValid="!$v.form.name.$error"
          @input="$v.form.name.$touch()"
          v-model="form.name"
          type="text"
          layout="vertical"
          :placeholder="$t('data.text')"
          :label="$t('data.text')"
        />

        <h6 class="mt-4">{{ $t("data-category.text") }}</h6>
        <filter-select
          id="categoryFilterq"
          ref="categoryFilterq"
          :placeholder="$t('data-category.text')"
          :multiple="false"
          @filter="onCategorySearch"
          :selected="form.category"
          @changed="onCategorySelect"
        />

        <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
          {{ $t("common.save") }}
        </sweet-button>

        <sweet-button @click="cancel()" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="mt-2 ml-2">
          {{ $t("common.cancel") }}
        </sweet-button>
      </div>
    </div>
  </form>
</template>

<script>
import LibraryItems from "@cc/library-items";
import Form from "./organization-data-category-form.vue";

import { maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  props: ["hide-library"],
  components: {
    LibraryItems,
    Form,
  },
  data() {
    return {
      form: { name: undefined },
      formError: undefined,
      entityName: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
        this.entityName = this.form.name;
      },
    },
    copingEntity: {
      deep: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
        this.entityName = this.form.name;
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters["organizationData/isUpdating"];
    },
    editedEntity() {
      return this.$store.getters["organizationData/editedEntity"];
    },
    copingEntity() {
      return this.$store.getters["organizationData/copingEntity"];
    },
    isEditMode() {
      return this.$store.getters["organizationData/isEditMode"];
    },
    showLibraryItems() {
      return !this.hideLibrary && !this.isEditMode && !this.isCoping;
    },
    isCoping() {
      return this.$store.getters["organizationData/isCoping"];
    },
  },
  mounted() {},
  methods: {
    customLabel(value) {
      return this.$options.filters.translate(value.name);
    },
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("organizationData/save", this.form);
        this.form = {};
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    cancel() {
      this.$store.dispatch("organizationData/resetForm");
    },
    rightPanelClosed() {
      this.$refs.categoryFilter.reset();
    },

    async onCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`dataCategory/paginate`, {
        options: { limit: 20 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onFormSave(item) {
      this.form = { ...this.form, category: { ...item, _id: item.libraryItem } };
    },
    onCategorySelect(item) {
      this.form = { ...this.form, category: item };
    },
  },
};
</script>
